document.addEventListener('DOMContentLoaded', () => {

  document.querySelectorAll('.product-gallery').forEach(gallery => {

    const images = gallery.querySelectorAll('img');

    if (images.length <= 1) return;

    let interval;

    gallery.closest('.card-wrapper').addEventListener('mouseenter', () => {

      let index = 0;

      interval = setInterval(() => {

        images.forEach(img => img.style.display = 'none');

        images[index].style.display = 'block';

        index = (index + 1) % images.length;

      }, 1000);

    });

    gallery.closest('.card-wrapper').addEventListener('mouseleave', () => {

      clearInterval(interval);

      images.forEach((img, i) => {
        img.style.display = i === 0 ? 'block' : 'none';
      });

    });

  });

});